<!-- =========================================================================================
  File Name: UserEditTabInformation.vue
  Description: User Edit Information Tab content
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
    <div id="user-edit-tab-info">

        <!-- Avatar Row -->
        <div class="vx-row">
            <div class="vx-col w-full">
                <div class="flex items-start flex-col sm:flex-row">
                    <img :src="dataImg" class="mr-8 rounded h-24 w-24"/>
                    <!-- <vs-avatar :src="data.avatar" size="80px" class="mr-4" /> -->
                    <div>
                        <p class="text-lg font-medium mb-2 mt-4 sm:mt-0">{{ data.name }}</p>
                        <input type="file" class="hidden" ref="update_avatar_input" @change="update_avatar"
                               accept="image/*">

                        <!-- Toggle comment of below buttons as one for actual flow & currently shown is only for demo -->
                        <input type="file" class="hidden" ref="updateImgInput" @change="updateCurrImg" accept="image/*">
                        <vs-button class="mr-4 mb-4" @click="$refs.updateImgInput.click()">Zmień logo</vs-button>
<!--                         <vs-button type="border" class="mr-4" @click="$refs.update_avatar_input.click()">Change Avatar</vs-button>-->

                        <vs-button type="border" color="danger">Usuń logo</vs-button>
                    </div>
                </div>
            </div>
        </div>

        <!-- Content Row -->
        <div class="vx-row">
            <div class="vx-col w-full">
                <vs-input class="w-full mt-4" label="Nazwa firmy" v-model="data_local.company"
                          v-validate="'required|alpha_num'" name="username"/>
                <span class="text-danger text-sm" v-show="errors.has('company')">{{ errors.first('company') }}</span>
            </div>
            <div class="vx-col w-full">
                <vs-input class="w-full mt-4" label="Ulica" v-model="data_local.street"
                          v-validate="'required|alpha_num'" name="street"/>
                <span class="text-danger text-sm" v-show="errors.has('street')">{{ errors.first('street') }}</span>
            </div>
        </div>
        <div class="vx-row">
            <div class="vx-col md:w-1/3 w-full">
                <vs-input class="w-full mt-4" label="Kod pocztowy" v-model="data_local.zip_code"
                          v-validate="'required|alpha_spaces'" name="zip_code"/>
                <span class="text-danger text-sm" v-show="errors.has('zip_code')">{{ errors.first('zip_code') }}</span>
            </div>
            <div class="vx-col md:w-2/3 w-full">
                <vs-input class="w-full mt-4" label="Miasto" v-model="data_local.city" type="city"
                          v-validate="'required|email'" name="city"/>
                <span class="text-danger text-sm" v-show="errors.has('city')">{{ errors.first('city') }}</span>
            </div>
        </div>
        <div class="vx-row">
            <div class="vx-col w-full">
                <vs-input class="w-full mt-4" label="NIP" v-model="data_local.nip"
                          v-validate="'required|alpha_num'" name="nip"/>
                <span class="text-danger text-sm" v-show="errors.has('nip')">{{ errors.first('nip') }}</span>
            </div>
            <div class="vx-col w-full">
                <vs-input class="w-full mt-4" label="Numer telefonu" v-model="data_local.mobile"
                          v-validate="'required|alpha_num'" name="mobile"/>
                <span class="text-danger text-sm" v-show="errors.has('mobile')">{{ errors.first('mobile') }}</span>
            </div>
            <div class="vx-col w-full">
                <vs-input class="w-full mt-4" label="Kod promocyjny" v-model="data_local.promo"
                          v-validate="'required|alpha_num'" name="promo"/>
                <span class="text-danger text-sm" v-show="errors.has('promo')">{{ errors.first('promo') }}</span>
            </div>
        </div>

        <!-- Save & Reset Button -->
        <div class="vx-row">
            <div class="vx-col w-full">
                <div class="mt-8 flex flex-wrap items-center">
                    <vs-button class="mt-2" @click="save_changes" :disabled="!validateForm">Zapisz zmiany
                    </vs-button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import vSelect from 'vue-select'

export default {
    components: {
        vSelect
    },
    props: {
        data: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            dataImg: null,
            data_local: JSON.parse(JSON.stringify(this.data)),

            statusOptions: [
                {label: 'Active', value: 'active'},
                {label: 'Blocked', value: 'blocked'},
                {label: 'Deactivated', value: 'deactivated'}
            ],
            roleOptions: [
                {label: 'Admin', value: 'admin'},
                {label: 'User', value: 'user'},
                {label: 'Staff', value: 'staff'}
            ]
        }
    },
    computed: {
        status_local: {
            get() {
                return {label: this.capitalize(this.data_local.status), value: this.data_local.status}
            },
            set(obj) {
                this.data_local.status = obj.value
            }
        },
        role_local: {
            get() {
                return {label: this.capitalize(this.data_local.role), value: this.data_local.role}
            },
            set(obj) {
                this.data_local.role = obj.value
            }
        },
        validateForm() {
            return !this.errors.any()
        }
    },
    methods: {
        updateCurrImg (input) {
            if (input.target.files && input.target.files[0]) {
                const reader = new FileReader()
                reader.onload = e => {
                    this.dataImg = e.target.result
                }
                reader.readAsDataURL(input.target.files[0])
            }
        },
        capitalize(str) {
            return str;
            if (str) {
                return str.slice(0, 1).toUpperCase() + str.slice(1, str.length)
            }

            return str;
        },
        save_changes() {
            /* eslint-disable */
            if (!this.validateForm) return

            // Here will go your API call for updating data
            // You can get data in "this.data_local"

            /* eslint-enable */
        },
        reset_data() {
            this.data_local = JSON.parse(JSON.stringify(this.data))
        },
        update_avatar() {
            // You can update avatar Here
            // For reference you can check dataList example
            // We haven't integrated it here, because data isn't saved in DB
        }
    }
}
</script>
